class BlurredTitle extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.previousY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.previousY = this.lastKnownY
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setBlur()
  }

  setBlur () {
    if (!this.offsetHeight) return

    const scrollingDown = this.lastKnownY > this.previousY

    const rect = this.getBoundingClientRect()
    const viewportHeight = window.innerHeight

    if (!scrollingDown || rect.top < viewportHeight * 0.5) {
      this.style.filter = 'blur(0px)'
      return
    }

    const maxBlur = 8

    const progress = Math.max(
      0,
      Math.min((rect.top - viewportHeight * 0.5) / (viewportHeight * 0.5), 1),
    )

    const blurAmount = maxBlur * progress

    this.style.filter = `blur(${blurAmount}px)`
  }
}

if (!customElements.get('blurred-title')) {
  customElements.define('blurred-title', BlurredTitle)
}
